<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Tier Downgrade</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">
        Dashboard
      </router-link>
      /

      <b>Marketing</b> /
      <b>Tier Downgrade</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    
    <div class="row mb-4">
      <div class="col-lg-12 col-md-12">
        <div class="card mb-4">
          <form class="card-body" @submit.prevent="handleSubmission">
            <div class="col-12 mb-4">
              <label><b>Note</b></label>
              <input class="form-control" type="text" v-model="data.content" required />
              <p>How to input: <br/>You need to have at least {points} points to maintain {tier} tier.</p>

              <p>E.g. How it will be displayed in the mobile app for Platinum: <br/> You need to have at least 15,000 points to maintain Platinum tier.</p>
            </div>

            <div class="col-5 mb-4">
              <label><b>Expiry</b></label>
              <div class="row col-5">
                <input class="form-control col" type="text" v-model="data.days" required />
                <div class="col">
                  Days
                </div>
              </div>
            </div>

            <div class="float-left ml-3">
              <button class="btn btn-primary" type="submit">Submit</button>
            </div>
          </form>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { getTier, storeTier } from '../../../services/GiftServices';

export default {
  components: {

  },

  data() {
    return {
      data: {
        content: '',
        days: ''
      }
    };
  },

  methods: {
    async fetchData() {
      try {
        const response = await getTier();

        if(response.data.success) {
          this.data = response.data.data;
        }

        if(this.data == null) {
          this.data = {
            content: '',
            days: ''
          }
        } 
      } catch (e) {
        console.error(e)
      }
    },

    async handleSubmission() {
      try {
        const response = await storeTier(this.data);

        swal({
          icon: response.data.success ? 'success' : 'error',
          text: response.data.message
        });
      } catch (e) {
        console.error(e)
      }
    }
  },

  async mounted() {
    await this.fetchData();
  }
};
</script>
